<template>
  <v-wait for="ariza-kayit-inserting">
    <template slot="waiting">
      <div class="vue-wait-class">
        <img src="static/loading.svg" />
        <p>Kayıt yapılıyor...</p>
      </div>
    </template>
    <div class="py-3 text-center">
      <h2>Arızalı Cihaz Kayıt Formu</h2>
      <p class="lead">Gelen ürüne ait bilgileri aşağıdaki forma işleyiniz.</p>
      <div class="container-fluid stepper">
        <div class="row">
          <div class="col-md-3 border step justify-content-between">
            <div class="badge badge-primary step-number">1</div>
            <div class="step-header">GENEL BİLGİLER</div>
            <div class="step-description">Gönderici, kargo, adres vb. bilgiler</div>
          </div>
          <div class="col-md-3 border step active">
            <div class="badge badge-primary step-number">2</div>
            <div class="step-header">GENEL BİLGİLER</div>
            <div class="step-description">Gönderici, kargo, adres vb. bilgiler</div>
          </div>
          <div class="col-md-3 border step">
            <div class="badge badge-primary step-number">3</div>
            <div class="step-header">GENEL BİLGİLER</div>
            <div class="step-description">Gönderici, kargo, adres vb. bilgiler</div>
          </div>
          <div class="col-md-3 border step">
            <div class="badge badge-primary step-number">4</div>
            <div class="step-header">GENEL BİLGİLER</div>
            <div class="step-description">Gönderici, kargo, adres vb. bilgiler</div>
          </div>
        </div>
        <div class="row border">
          <div class="col-md-12 p-4"></div>
        </div>
      </div>
    </div>
  </v-wait>
</template>

<script>
/* eslint-disable */

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import axios from 'axios'

export default {
  name: 'ArizaKayitPage',
  components: {
    'datepicker': Datepicker
  },
  data () {
    return {
      e1: 0,
      procStatus: 0,
      deviceId: '',
      deviceModel: '',
      deviceInWarrantyPeriod: false,
      equipments: [],
      customerTitle: '',
      customerAddress: '',
      deviceModel: '',
      vehicleName: '',
      arrivalDocumentCode: '',
      senderName: '',
      incomingAddress: '',
      arrivalDate: '',
      arizaNote: '',
      pieces: [
        {"PieceName": "GSM Anteni", "PieceId": 1, "Status": 0, "Group": 2},
        {"PieceName": "GPS Anteni", "PieceId": 2, "Status": 0, "Group": 2},
        {"PieceName": "Power Kablosu", "PieceId": 3, "Status": 0, "Group": 2},
        {"PieceName": "SIM Kart", "PieceId": 4, "Status": 0, "Group": 2},
        {"PieceName": "Röle", "PieceId": 5, "Status": 0, "Group": 2},
        {"PieceName": "Röle Soketi", "PieceId": 6, "Status": 0, "Group": 2},
        {"PieceName": "Bloke Kablo", "PieceId": 7, "Status": 0, "Group": 2},
        {"PieceName": "İkili Max Ara Kablo", "PieceId": 8, "Status": 0, "Group": 2},
        {"PieceName": "LNX-66 IP Kamera", "PieceId": 9, "Status": 0, "Group": 1},
        {"PieceName": "LNC-104 IP Kamera", "PieceId": 10, "Status": 0, "Group": 1},
        {"PieceName": "DVR Kamera Power Kablo", "PieceId": 11, "Status": 0, "Group": 1},
        {"PieceName": "NVR Çoklu Power Kablo", "PieceId": 13, "Status": 0, "Group": 1},
        {"PieceName": "Ahtapot Kablo", "PieceId": 14, "Status": 0, "Group": 1},
        {"PieceName": "Acil Durum Butonu", "PieceId": 15, "Status": 0, "Group": 3},
        {"PieceName": "Monitör", "PieceId": 16, "Status": 0, "Group": 3},
        {"PieceName": "Kimlik Tanıma Birimi", "PieceId": 17, "Status": 0, "Group": 3},
      ],
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      }
    }
  },
  computed: {
    gotPieceCount: function() {
      let len = this.equipments.length
      len = this.deviceId.length == 15 ? len + 1 : len
      return len
    }
  },
  methods: {
    insertArizaKaydi() {
      if(!this.arrivalDate) {
        this.$toasted.error('Geçerli bir tarih seçmediniz', this.toastOptions)
        return
      }

      if(!this.regexCheck(this.deviceId)) {
        this.$toasted.error('IMEI numarası doğru girilmedi.', this.toastOptions)
        return
      }

      this.$wait.start('ariza-kayit-inserting')

      let sessionid = localStorage.getItem('utks-sessionid')
      let insertJson = {}
      insertJson.SessionId = sessionid
      insertJson.DeviceId = this.deviceId
      insertJson.DeviceInWarrantyPeriod = this.deviceInWarrantyPeriod
      insertJson.ArrivalDate = moment(this.arrivalDate).format('DD.MM.YYYY')
      insertJson.ArrivalDocumentCode = this.arrivalDocumentCode
      insertJson.IncomingAddress = this.incomingAddress
      insertJson.IncomingSenderName = this.senderName
      insertJson.IncomingPieces = this.equipments
      insertJson.Note = this.arizaNote
      console.log(insertJson)

      axios.post("/api/arizakayit/ekle", insertJson)
      .then(response => {
        if(response.data.HasError == false) {
          this.$router.push('/ariza-kayitlari')
          this.$toasted.success('Arıza kaydı oluşturuldu !', this.toastOptions)      
        }
        else {
          this.$toasted.error('Kayıt oluşturulamadı. Durum mesajı: ' + response.data.ErrorMessage, this.toastOptions)      
        }

        this.$wait.end('ariza-kayit-inserting')
      })
    }, 
    dateFormatter(date) {
      return moment(date).format('DD.MM.YYYY')
    },
    getDeviceInfo(e) {
      this.procStatus = 1
      e.preventDefault()
      let sessionid = localStorage.getItem('utks-sessionid')
      axios
      .post('/api/device/deviceInformation', { "SessionId": sessionid, "DeviceId": this.deviceId })
      .then(response => {
        this.customerTitle = response.data.customerTitle
        this.vehicleName = response.data.vehicleName
        this.deviceModel = response.data.deviceModel
        this.customerAddress = response.data.customerAddress
        this.procStatus = 0
      })
      .catch(error => { 
        console.log(error)
        this.procStatus = 0
      })
    },
    regexCheck(imei) {
      const regex = /^\d{15}$/
      let m = regex.exec(imei);
      
      if(m == null || m.length == 0)
        return false
      else
        return true
    },
  },
  mounted() {
    moment.locale('tr')
    //this.arrivalDate = moment().format('L')
  }
}
</script>

<style scoped>
  
  .step { padding: 14px; cursor: pointer;}
  .step.active { background-color: #010919; border-color: #010919; }
  .step .step-number {
    float:left;
    display: inline-flex;
    padding: 10px 13px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    margin-right: 10px;
  }
  .step .step-header {
    display: block;
    float: left;
    text-align: left;
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    justify-content: left;
  }
  .step .step-description {
    display: block;
    float: left;
    text-align: left;
    font-size: 12px;
    line-height: 15px;
    font-weight: 400;
    justify-content: left;
  }
  .step.active .step-header {
    color: #FFF;
  }
  .step.active .step-description {
    color: #FFF;
  }

  .container {
    max-width: 1280px;
  }
  .transparent-label { color: rgba(0,0,0,0);}
  .light-text { 
    font-weight: 400 !important; 
    -webkit-user-select: none; /* Safari */        
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
  }
  .lh-condensed { line-height: 1.25; } 

  /* The switch - the box around the slider */
.switch {
  position: absolute;
  display: inline-block;
  z-index: 1;
  right: 10px;
  top: 10px;
  width: 40px;
  height: 25px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #1DB954;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #F00;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 26px;
}

.slider.round:before {
  border-radius: 50%;
}

input[type="text"].loading {
  background-image: url("~/static/loading.svg");
  background-size: 32px 32px;
  background-position:right center;
  background-repeat: no-repeat;
}

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/components/ArizaKayit_v2.vue